module.exports = __webpack_public_path__ + "img/pushup.0c3130e1.svg";